export default function createAccordion() {
  let title = $('.accordion-title');

  title.on('click', function (event) {
    let parent = $(this).parent('.accordion-item');

    event.preventDefault();
    parent.toggleClass('active').find('.accordion-content').slideToggle();
    parent.siblings().removeClass('active').find('.accordion-content').slideUp();
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/accordion.js